<template>
  <el-dialog destroy-on-close v-model="dialogFormVisible" title="新增" :close-on-click-modal="false" class="button_bg" width="30%">
    <el-form ref="dataForm" :rules="rules" :model="temp" label-position="right" label-width="140px">
      <el-form-item label="新增薪酬类型：" prop="wageType">
        <el-select v-model="temp.wageType"  style="width:80%;" size="mini">
          <el-option v-for="item in sakayType" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <template v-if="temp.wageType == '个人生产经营所得(查账征收)'">
        <el-form-item label="薪酬所属期起：">
          <el-date-picker size="mini" style="width:80%;margin-left:5px" v-model="temp.dateStart" type="month" placeholder="选择薪酬所属期" value-format="YYYYMM"></el-date-picker>
        </el-form-item>
        <el-form-item label="薪酬所属期止：">
          <el-date-picker size="mini" style="width:80%;margin-left:5px" v-model="temp.dateEnd" type="month" placeholder="选择薪酬所属期" disabled value-format="YYYYMM"></el-date-picker>
        </el-form-item>

        <el-form-item label="企业类型：" prop="wageType">
          <el-select v-model="temp.comType"  style="width:30%;" size="mini">
            <el-option label="个体工商户" value="个体工商户"></el-option>
            <el-option label="个人独资企业" value="个人独资企业"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="征收方式：" prop="wageType">
          <el-select disabled v-model="zsfs"  style="width:30%;" size="mini">
            <el-option label="据实预缴" value="据实预缴"></el-option>
          </el-select>
        </el-form-item>
      </template>
      <template v-if="temp.wageType == '正常工资薪资'">
        <el-form-item label="支付方式：">
          <el-select v-model="temp.paymentMode" style="width:80%;" size="mini">
            <el-option v-for="item in paytype" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="银行账户：" v-if="temp.paymentMode === '银行'">
          <subject-list subjectName="" v-model:subjectId="temp.paySubjectId" v-model:fzhsItemId="temp.payFzhsId" :codes="['1002']"></subject-list>
        </el-form-item>
        <el-form-item label="现金：" v-if="temp.paymentMode === '现金'">
          <subject-list subjectName="" v-model:subjectId="temp.paySubjectId" v-model:fzhsItemId="temp.payFzhsId" :codes="['1001']"></subject-list>
        </el-form-item>
        <el-form-item label="其他：" v-if="temp.paymentMode === '其他'">
          <subject-list subjectName="" v-model:subjectId="temp.paySubjectId" v-model:payFzhsId="temp.payFzhsId" :payCode="['2241']"></subject-list>
        </el-form-item>
      </template>
    </el-form>
    <div class="dialog-footer">
      <el-button @click="dialogFormVisible = false" size="mini">取消</el-button>
      <el-button type="primary" @click="createData()" size="mini">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { saveEaSalarySheet } from '@/api/salary.js'
export default {
  name: 'addSalary',
  data() {
    return{
      dialogFormVisible:false,
      temp: {
        comType: "个体工商户",
        zsfs: "据实预缴",
        wageType:'正常工资薪资',
        paymentMode: '无',
        period: '',
        comId: '',
        bankAccountId: '',
        paySubjectId: 0,
        payFzhsId: 0,
      },
      rules: {
        wageType:[{ required: true, message: "薪酬所属期不能为空", trigger: "change" }]
      },
      dialogStatus: '',
      textMap: {
        update: '修改薪酬',
        create: '新增薪酬'
      },
      sakayType:[{
        value: '正常工资薪资',
        label: '正常工资薪资'
      }, 
      {
        value: '个人生产经营所得(查账征收)',
        label: '个人生产经营所得(查账征收)'
      }
      ],
      paytype: [{
        value: '无',
        label: '只计提，不发放'
      },{
        value: '银行',
        label: '当月计提，银行发放'
      },{
        value: '现金',
        label: '当月计提，现金发放'
      },{
        value: '其他',
        label: '当月计提，其他发放'
      }],
      zsfs: "据实预缴",
      contentStyleObj:{}, //高度变化
      } 
  },
  methods: {
    //弹窗
    openSalary(row){
      this.temp = {
        comType: "个体工商户",
        zsfs: "据实预缴",
        wageType:'正常工资薪资',
        paymentMode: '无',
        period: '',
        comId: '',
        bankAccountId: '',
        paySubjectId: 0,
        payFzhsId: 0,
        dateEnd:this.$store.getters['user/comInfo'].period
      }
      console.log(this.temp.dateEnd);
      if(row){
        this.temp = row
      }
      this.dialogFormVisible = true
    },
    createData() {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          this.temp.comId = this.temp.comId*1
          this.temp.bankAccountId = this.temp.bankAccountId*1
          saveEaSalarySheet(this.temp).then(e => {
            if(e.data.msg == 'success'){
              this.$qzfMessage("创建成功")
              this.$emit("success")
              this.dialogFormVisible = false
            }
          })
        }
      })
  },
  }
}
</script>

<style>
.dialog-footer {
    text-align: right;
}
</style>